import React, { useEffect, useState } from 'react';
import { SpeakerCard } from '../../speakerCard';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import featureToggles from '../../../utils/featureToggles';
import ComingSoonPage from '../comingSoonPage';
import curators from '../../../assets/static-data/2025/curators.json';

const SplitCuratorsPage = () => {

  const [curatorList, setCuratorList] = useState(curators);

  const { t } = useTranslation();

  const thumbnailDirectory = '/assets/images/curators/thumbnails/';

  const renderCuratorsCards = () => {
    return <ul className="con-list">
      {curators.map((item) => {
        return <SpeakerCard
          speakerId={item.speakerId} 
          key={item.speakerId}
          imageUrl={thumbnailDirectory + item.image}
          name={item.name}
          jobTitle={item.jobTitle}
          description={item.description}
        />;
      })}
    </ul>;
  };

  useEffect(() => {
    document.title = t('Pages.Curators.Title');
    if (!curatorList) {
      setCuratorList(curatorList);
    }
  }, []);

  if (featureToggles.curators()) {
    return <ComingSoonPage title={t('Pages.Curators.Title')} header={t('Pages.Curators.Header')} />;
  }

  return (
    <div className="con-container">
      <div className="con-content">
        <div className="con-flex__container">
          <h1 className="con-heading aicon-heading__l--margin-bottom-3">{t('Pages.Curators.Header')}</h1>
        </div>
        {renderCuratorsCards()}
      </div>
    </div>
  );
};

SplitCuratorsPage.propTypes = {
  societalCuratorList: PropTypes.array,
  t: PropTypes.func
};

export default SplitCuratorsPage;
